import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "Create Catalog from URL",
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    width: "60%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", null, [
        _createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(_component_el_button, {
          type: "primary",
          onClick: _ctx.onCreateCatalogFromUrl
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]), [
          [_directive_loading, _ctx.isCreating]
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          "label-width": "20%",
          class: "font-bold",
          modelValue: _ctx.state.form,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.form) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "URL:",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.form.productStoreUrl,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.form.productStoreUrl) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "Product code:" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.form.productCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.form.productCode) = $event)),
                  class: "w-1/2"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "font-bold",
              label: "Catalog Type:",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.state.form.type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.form.type) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
                { value: 'pod', title: 'POD' },
                { value: 'drop', title: 'DROP' },
                { value: 'fake', title: 'FK' },
              ], (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.title,
                        value: item.value,
                        size: 25
                      }, null, 8, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_divider),
            _createVNode(_component_el_form_item, { label: "Store:" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.state.form.store,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.form.store) = $event)),
                  placeholder: "Store",
                  clearable: "",
                  filterable: "",
                  onChange: _ctx.onSelectStore
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stores, (store) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: store.id,
                        label: store.appShopUrl,
                        value: store.id,
                        clearable: ""
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "App Shop Url:",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.form.appShopUrl,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.form.appShopUrl) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "App Api Key:",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.form.appApiKey,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.form.appApiKey) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "App Password:",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.state.form.appPassword,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.form.appPassword) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}